import { WarningAmber } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import { type FC } from 'react';

import { useDraftTimelogStore } from '@/features/draftTimelogs/model';
import { plural, pluralize } from '@/utils/pluralize';

import s from './DraftWarningBanner.module.scss';

const DRAFT_COUNT_VARIANTS = {
  one: 'неопубликованный черновик',
  two: 'неопубликованных черновика',
  five: 'неопубликованных черновиков',
} as const;

const VERB_VARIANTS = {
  one: 'остался',
  two: 'остались',
  five: 'остались',
} as const;

export const DraftWarningBanner: FC = observer(() => {
  const { isViewingSelf, hasDrafts, unpublishedDraftCount, isPeriodPast, loadingStage } =
    useDraftTimelogStore();

  if (!isViewingSelf || !hasDrafts || !isPeriodPast || loadingStage.isLoading) {
    return null;
  }

  const countLabel = pluralize(unpublishedDraftCount, DRAFT_COUNT_VARIANTS);
  const verb = plural(unpublishedDraftCount, VERB_VARIANTS);

  return (
    <div className={`${s.strip} ${s.strip_warning}`} role="status">
      <WarningAmber className={`${s.strip__icon} ${s.strip__icon_warning}`} aria-hidden />
      <span className={s.strip__text}>
        За прошедший период {verb} {countLabel}. Не забудьте их опубликовать.
      </span>
    </div>
  );
});
